import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import { Navbar } from "./components/Navbar";
import { CrisisBanner } from "./components/CrisisBanner";
import { Hero } from "./components/Hero";
import { SobreMim } from "./components/SobreMim";
import { AreasAtuacao } from "./components/AreasAtuacao";
import { AvaliacaoNeuro } from "./components/AvaliacaoNeuro";
import { Depoimentos } from "./components/Depoimentos";
import { FAQSection } from "./components/FAQSection";
import { Contato } from "./components/Contato";
import { Footer } from "./components/Footer";
import { WhatsAppFloat } from "./components/WhatsAppFloat";

const Landing = () => (
  <div className="App min-h-screen bg-background">
    <CrisisBanner />
    <Navbar />
    <main>
      <Hero />
      <SobreMim />
      <AreasAtuacao />
      <AvaliacaoNeuro />
      <Depoimentos />
      <FAQSection />
      <Contato />
    </main>
    <Footer />
    <WhatsAppFloat />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
      </Routes>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
